import { apiUrl } from '../configs/config.constants'
import { QrSaveOutcome, saveQrImage } from '../utils/qrImage'
import { httpPost } from './Http.service'

/**
 * Saves the QR to the device and tells the server the customer now has it, which is
 * what stops it being offered again on their next booking.
 *
 * The report is skipped unless the file actually reached the customer, and its outcome
 * never affects theirs: if the report fails they still have the image, and the only
 * cost is being shown the QR once more.
 */
export async function saveCustomerQr(
  dataUrl: string,
  code: string | undefined,
  filename = 'booking-qr.png',
): Promise<QrSaveOutcome> {
  const outcome = await saveQrImage(dataUrl, filename)

  if (!code || outcome === 'cancelled' || outcome === 'manual') {
    return outcome
  }

  try {
    await httpPost(apiUrl.customerQr.saved, { code })
  } catch (error) {
    console.error(error)
  }

  return outcome
}
